<template>
  <div
    class="app-snackbar"
    v-if="snackbar.display"
    v-bind:class="snackbar.mode"
  >
    <span>{{ snackbar.label }}</span>
  </div>
</template>

<script>
export default {
  methods: {
    timeout(duration) {
      const timeout = setTimeout(() => {
        this.$store.commit('ui/resetSnackbar');
      }, duration);
      return 1;
    },
  },
  computed: {
    snackbar() {
      const value = this.$store.state.ui.snackbar;
      if (!!value.duration) {
        setTimeout(() => {
          this.$store.commit('ui/resetSnackbar');
        }, value.duration);
      }
      return value;
    },
  },
};
</script>
<style lang="scss">
.app-snackbar {
  position: absolute;
  z-index: 10;
  padding: 1rem;
  top: calc(100vh - 5rem);
  right: 0;
  border-radius: 8px 0 0 8px;
  font-weight: 600;
  box-shadow: 0 0 3px rgba(230, 224, 224, 0.593);
  color: white;
  transition: all 1s;
}
.danger {
  background: #fd5d5c;
}
</style>
